export const blockIconsCommonactionsSupervisorAccountNew = (
	<span className='material-symbols-outlined'>supervisor_account</span>
);
